import { type DeviceManagerHost } from '@yandex-360/telemost-sdk/device-manager';

import { browser } from '../../helpers/browser-capabilities';
import { COUNTERS } from '../../helpers/logger-enums';
import { createLogger } from '../../helpers/loggerFacade';
import { getDesktopVideoConstraints, getMobileVideoConstraints } from '../../helpers/video-resolution-constraints';

const logger = createLogger('device-manager');

export function createTelemostDeviceManagerHost(): DeviceManagerHost {
    return {
        logger,
        browser,
        getDesktopVideoConstraints,
        getMobileVideoConstraints,
        unmuteMicrophoneCounter: COUNTERS.UNMUTE_MICROPHONE_DELTA,
        unmuteCameraCounter: COUNTERS.UNMUTE_CAMERA_DELTA,
    };
}
